import http from '../api'

import Paginator from '../_paginator';

let getAllCompanies = (data) => {
  return new Paginator({
    url: '/companies/',
    config: data,
  });
};

let updateCompany = (data) => {
    return http.put(`companies/${data.id}`, data)
}

let createCompany = (data) => {
    return http.post('companies', data)
}

let getCompany = (data)=>{
    return http.get(`get-company/${data}`);
}

export default {
    getAllCompanies,
    updateCompany,
    getCompany,
    createCompany
}